import classNames from 'classnames';
import { FC, useCallback, useEffect, useRef, useState } from 'react';

import { CartTooltip, useCartStore } from '@/features/cart';
import { Bullet, Icon } from '@/shared/ui';
import { useMenuStore } from '@/widgets/menu/model/store';

import styles from './cartToggle.module.scss';

const CartToggle: FC = () => {
  const { items, totalCount, totalPrice } = useCartStore();
  const closeMenu = useMenuStore((state) => state.close);
  const [active, setActive] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const closeTooltip = useCallback(() => setActive(false), []);
  const itemsQuantity = items.reduce((sum, item) => sum + item.quantity, 0);

  useEffect(() => {
    if (!active) return;

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        closeTooltip();
        buttonRef.current?.focus();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [active, closeTooltip]);

  function toggleActive() {
    if (!active) {
      closeMenu();
    }
    setActive((prev) => !prev);
  }

  return (
    <div className={styles.toggle}>
      <button
        ref={buttonRef}
        aria-expanded={active}
        aria-label="Корзина"
        className={styles.toggle__btn}
        title="Корзина"
        onClick={toggleActive}
      >
        {itemsQuantity === 0 ? (
          <Icon name="cartEmpty" />
        ) : (
          <Bullet count={itemsQuantity} />
        )}
      </button>
      <CartTooltip
        className={classNames(
          styles.toggle__tooltip,
          active && styles.toggle__tooltip_active,
        )}
        isActive={active}
        value={{
          items,
          count: totalCount,
          total: totalPrice,
        }}
        onClose={closeTooltip}
      />
    </div>
  );
};

export default CartToggle;
